import { IconRegistryConfig } from './icon-registry.service';

export function provideIconConfig(path: string) {
  return {
    provide: IconRegistryConfig,
    useValue: {
      path,
    },
  };
}
